module.exports={CapabilitiesAffected:"Capabilities Affected:",ShowRelated:"Show {relatedCount} Related"};